export interface HashtagMatch {
  text: string;
  start: number;
  end: number;
}

export const detectHashtags = (text: string): HashtagMatch[] => {
  const hashtagRegex = /#[a-zA-Z0-9_]+/g;
  const matches: HashtagMatch[] = [];
  let match;

  while ((match = hashtagRegex.exec(text)) !== null) {
    matches.push({
      text: match[0],
      start: match.index,
      end: match.index + match[0].length
    });
  }

  return matches;
};

export const formatTextWithHashtags = (text: string, hashtags: HashtagMatch[]) => {
  if (hashtags.length === 0) return text;

  let result = '';
  let lastIndex = 0;

  hashtags.forEach((hashtag) => {
    // Add text before hashtag
    result += text.slice(lastIndex, hashtag.start);
    // Add hashtag with special marker
    result += `<span class="hashtag-highlight">${hashtag.text}</span>`;
    lastIndex = hashtag.end;
  });

  // Add remaining text
  result += text.slice(lastIndex);
  return result;
};